<!-- Barra de loading -->
<ngx-loading-bar
  color="#38B463"
  height="5px"
  [includeSpinner]="false"
  [fixed]="true"
  ref="router"
></ngx-loading-bar>

<div [ngClass]="{ 'dark-mode': isDarkMode, 'light-mode': !isDarkMode }">
  <div id="preloader">
    <div class="animate-pulse">
      <img [src]="assetBaseUrl + 'images/logo-colorido.png'" alt="Wosi Seguros Sustentáveis">
    </div>
  </div>
</div>

<!-- Conteúdo da aplicação -->
<div [@routeAnimations]="prepareRoute(outlet)">
  <router-outlet #outlet="outlet"></router-outlet>
</div>

<app-toast-page></app-toast-page>

<app-accept-cookie></app-accept-cookie>

<app-chatbot-ia></app-chatbot-ia>

<!-- <button *ngIf="showInstallButton" (click)="instalarApp()">
  Instalar App
</button> -->
